import { Component, OnInit } from '@angular/core';
import { CoreService } from 'src/app/core/services/core.service';
import { ActivatedRoute } from '@angular/router';
import { Meta, Title } from '@angular/platform-browser';

@Component({
  selector: 'bs-page',
  templateUrl: './page.component.html',
  styleUrls: ['./page.component.scss']
})
export class PageComponent implements OnInit {

  public page = {
    title: '',
    body: this.coreService.generateBody(''),
  };
  public pageData: any;
  public carouselData: any = {items: []};

  constructor(
    public coreService: CoreService,
    private route: ActivatedRoute,
    private titleService: Title,
    private metaService: Meta,
  ) { }

  ngOnInit() {
    this.route.params.subscribe(
      params => {
        this.coreService
        .fetchData('pages/?filter[handle][eq]=' + this.route.snapshot.params['handle'])
        .subscribe((data: any) => {
          if (data.length > 0) {
            if (data[0].image) {
              ['og:image', 'twitter:image'].forEach((x) => this.metaService.updateTag({
                name: x,
                content: this.coreService.getCompressedImage(data[0].image.data.url)
              }));
              this.carouselData.items = [data[0].image ? {
                image: this.coreService.getCompressedImage(data[0].image.data.url),
                imageBackgroundPosition: data[0].imageBackgroundPosition,
                mobileImage: data[0].mobileImage ? this.coreService.getCompressedImage(data[0].mobileImage.data.url) : null,
                mobileImageBackgroundPosition: data[0].mobileImageBackgroundPosition,
                video: data[0].video ? data[0].video.data.url : '',
              } : undefined];
            }
            this.pageData = data[0];
            this.page.body = this.coreService.generateBody(data[0].body);
            this.page.title = data[0].title;

            this.titleService.setTitle(`${data[0].title} - British Shooting`);
            ['og:title', 'twitter:title'].forEach((x) => this.metaService.updateTag({
              name: x,
              content: `${data[0].title} - British Shooting`
            }));
            ['description', 'og:description', 'twitter:description'].forEach((x) => this.metaService.updateTag({
              name: x,
              content: data[0].description
                ? data[0].description
                : data[0].body
                    .replace(/<\/?[^>]+(>|$)/g, '')
                    .substring(0, 160)
                    .replace(/(^|\s)\S*$/, '')
                    .trim(),
            }));
          }
        });
      }
    );
  }

}
